// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__X9Njg","loaderOuter":"PageOverlayLoader_loaderOuter__2IQWu"};